window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.GenericPopupPanelBG = function() {
	this.initialize(img.SystemMessageAssets_GenericPopupPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,526,286);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.SystemMessageOneButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#67666F");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 134;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#67666F");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 134;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#67666F");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 134;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 134;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EgmRgFTMBMjAAAIAAKnMhMjAAAg");
	this.shape.setTransform(0,-6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EgmRAFUIAAqnMBMjAAAIAAKng");
	this.shape_1.setTransform(0,-6);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#EBEAEA").s().p("EgmRAFUIAAqnMBMjAAAIAAKng");
	this.shape_2.setTransform(0,-6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_2},{t:this.shape}]},1).to({state:[{t:this.shape_1},{t:this.shape}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-246,-41,492,70);


(lib.SystemMessageHalfButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#67666F");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 134;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 134;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#67666F");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 134;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start", "24px 'Open Sans'", "#67666F");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 134;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-23);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("AzIlTMAmRAAAIAAKnMgmRAAAg");
	this.shape.setTransform(0,-6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AzIFUIAAqnMAmRAAAIAAKng");
	this.shape_1.setTransform(0,-6);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#EBEAEA").s().p("AzIFUIAAqnMAmRAAAIAAKng");
	this.shape_2.setTransform(0,-6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_2},{t:this.shape}]},1).to({state:[{t:this.shape_1},{t:this.shape}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-123.5,-41,247,70);


(lib.SystemMessageBackgroundOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#EBEAEA").ss(1,0,1).p("EiXjhXfMEvHAAAMAAACu/MkvHAAAg");
	this.shape.setTransform(0.0155,0);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.498)").s().p("EiXjBXgMAAAiu/MEvHAAAMAAACu/g");
	this.shape_1.setTransform(0.0155,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SystemMessageBackgroundOverlay, new cjs.Rectangle(-971,-561,1942,1122), null);


(lib.TwoButtonsPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// lines
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#EBEAEA").ss(1,0,1).p("EAmSgFQMgmSAAAAAAFWIAAqmMgmRAAA");
	this.shape.setTransform(0.025,-0.225);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// button1
	this.button1 = new lib.SystemMessageHalfButton();
	this.button1.name = "button1";
	this.button1.setTransform(-123,5.5,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.button1).wait(1));

	// button2
	this.button2 = new lib.SystemMessageHalfButton();
	this.button2.name = "button2";
	this.button2.setTransform(122,5.5,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.button2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TwoButtonsPanel, new cjs.Rectangle(-246,-34.9,492.1,69.9), null);


(lib.OneButtonPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// lines
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#EBEAEA").ss(1,0,1).p("EAmSAAAMhMjAAA");
	this.shape.setTransform(0.025,-33.95);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// button1
	this.button1 = new lib.SystemMessageOneButton();
	this.button1.name = "button1";
	this.button1.setTransform(-0.5,5.5,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.button1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OneButtonPanel, new cjs.Rectangle(-246,-34.9,492.1,69.4), null);


(lib.SystemMessagePanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// headerTextField
	this.headerTextField = new cjs.Text("Title", "32px 'Open Sans'", "#67666F");
	this.headerTextField.name = "headerTextField";
	this.headerTextField.textAlign = "center";
	this.headerTextField.lineHeight = 44;
	this.headerTextField.lineWidth = 457;
	this.headerTextField.parent = this;
	this.headerTextField.setTransform(0,-104.1);
ranj.TextOffsetFixer.fix(this.headerTextField);

	this.timeline.addTween(cjs.Tween.get(this.headerTextField).wait(1));

	// bodyTextField
	this.bodyTextField = new cjs.Text("Lorem ipsum dolor sit amet", "20px 'Open Sans'", "#67666F");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.textAlign = "center";
	this.bodyTextField.lineHeight = 28;
	this.bodyTextField.lineWidth = 453;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(0,-41);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// buttonPanel1
	this.buttonPanel1 = new lib.OneButtonPanel();
	this.buttonPanel1.name = "buttonPanel1";
	this.buttonPanel1.setTransform(0,91);

	this.timeline.addTween(cjs.Tween.get(this.buttonPanel1).wait(1));

	// buttonPanel2
	this.buttonPanel2 = new lib.TwoButtonsPanel();
	this.buttonPanel2.name = "buttonPanel2";
	this.buttonPanel2.setTransform(0,91);

	this.timeline.addTween(cjs.Tween.get(this.buttonPanel2).wait(1));

	// bg
	this.instance = new lib.GenericPopupPanelBG();
	this.instance.setTransform(-263,-143);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// fallbackBg
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EgmRgTcMBMjAAAMAAAAm5MhMjAAAg");
	this.shape.setTransform(0,-0.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EgmRATdMAAAgm5MBMjAAAMAAAAm5g");
	this.shape_1.setTransform(0,-0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SystemMessagePanel, new cjs.Rectangle(-263,-446.8,2827.7,589.8), null);


(lib.SystemMessagePopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.SystemMessagePanel();
	this.panel.name = "panel";

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// overlay
	this.bg = new lib.SystemMessageBackgroundOverlay();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SystemMessagePopupSkin, new cjs.Rectangle(-970.5,-560.5,1941,1121), null);


// stage content:
(lib.SystemMessageAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: '7D87CBD7B91354468108248D37987D7F',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SystemMessageAssets/GenericPopupPanelBG.png", id:"SystemMessageAssets_GenericPopupPanelBG", bundle:"SystemMessageAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.SystemMessageAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.SystemMessageAssets;